import { Layout, theme } from 'antd';
import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSider from '../components/adminLayout/AdminSider';
import { getAdminLayoutCssVariables } from '../theme/adminLayoutTheme';
import useLocalizedNavigate from '../hooks/useLocalizedNavigate';
import '../components/adminLayout/AdminLayout.css';

const { Content, Sider } = Layout;

const MainLayout = ({ fullPage }) => {
  const navigate = useLocalizedNavigate();
  const { token } = theme.useToken();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout className="admin_layout" style={getAdminLayoutCssVariables(token)}>
      <Sider
        width={248}
        collapsedWidth={72}
        breakpoint="lg"
        collapsed={collapsed}
        onBreakpoint={(broken) => setCollapsed(broken)}
        className="admin_sider"
      >
        <AdminSider
          onSelect={navigate}
          collapsed={collapsed}
          onCollapse={() => setCollapsed((prev) => !prev)}
        />
      </Sider>

      <Layout className="admin_main">
        <Content className="admin_content">
          <Suspense fallback={null}>
            {fullPage ? (
              <Outlet />
            ) : (
              <div className="admin-layout-edit">
                <Outlet />
              </div>
            )}
          </Suspense>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
